import { configureStore } from '@reduxjs/toolkit';
import documentsReducer from './slices/documentsSlice';
import databaseReducer from './slices/databaseSlice';
import uiReducer from './slices/uiSlice';
import progressReducer from './slices/progressSlice';
import overridesReducer from './slices/overridesSlice';
import userReducer from './slices/userSlice';

export const store = configureStore({
  reducer: {
    documents: documentsReducer,
    database: databaseReducer,
    ui: uiReducer,
    overrides: overridesReducer,
    user: userReducer,
    progress: progressReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Disable the serializable check entirely in development for better performance
        // and to avoid warnings about intentionally non-serializable data (File objects, React components)
        warnAfter: 128,
        ignoredActions: ['persist/PERSIST'],
        // Ignore File objects in documents state (used for file uploads)
        // and columns in database state (contains React components for rendering)
        ignoredPaths: [
          'documents.proposalFile',
          'documents.proposalFiles',
          'documents.noteFile',
          'documents.noteFiles',
          'documents.securityFile',
          'documents.securityFiles',
          'documents.additionalFiles',
          'documents.archiveFiles',
          'documents.checklistFiles',
          'documents.masterFile',
          'database.columns', // Contains React components in column definitions
        ],
        ignoredActionPaths: ['payload', 'meta.arg'],
      },
    }),
});

export default store;